<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Ofertas de Rematrícula</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-w="12" v-if="error != ''">
          <vs-alert title="Atenção" class="margin" color="danger">
            {{ error }}
          </vs-alert>
          <vs-button
            icon="arrow_back"
            style="margin-top: 15px;"
            @click="goTo('/reenrollment', courseOffer)"
          >
            Voltar
          </vs-button>
        </vs-row>
        <vs-row
          v-else
          v-for="(courseOffer, index) in offers"
          :key="index"
          vs-w="12"
        >
          <vs-col>
            <vs-card style="height: 175px; box-shadow: 0px 0px 2px 1px #888888;">
              <div slot="header">
                <h4>{{ courseOffer.NOMECOMERCIAL }}</h4>
              </div>
              <div>
                <p>
                  <strong> {{ courseOffer.FILIALCAMPUS }}</strong>
                </p>
              </div>
              <div>
                <p>
                  <strong> Modalidade: </strong>
                  {{ courseOffer.MODALIDADE == "D" ? "Distância" : "Presencial" }}
                </p>

                <div v-if="courseOffer.MODALIDADE != 'D'">
                  <p><strong> Turno: </strong> {{ courseOffer.TURNO }}</p>
                </div>
                <div v-if="course.CODFILIALPOLO == courseOffer.CODCAMPUS">
                  <p><strong> *** Filial/Polo atual do aluno ***</strong></p>
                </div>
                <vs-button
                  v-if="courseOffer.NUMELETIVAS == 0"
                  :key="courseOffer.IDHABILITACAOFILIAL"
                  style="width: 100%; margin: 15px 0 10px 0;"
                  icon="local_offer"
                  @click="goTo('/classreenrollment', courseOffer)"
                >
                  Selecionar Oferta
                </vs-button>
                <vs-button
                  v-else
                  style="width: 100%; margin: 15px 0 10px 0;"
                  icon="local_offer"
                  @click="goTo('/electivereenrollment', courseOffer)"
                >
                  Selecionar Oferta
                </vs-button>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
      </section>
    </div>
    <ConsultValidationRem />
  </div>
</template>

<script>
import Course from "../services/courses";
import ConsultValidationRem from "../components/ConsultValidationRem.vue";
import {
  formatDateToUSA,
  getLoginDataFromStorage,
  getStepsInformation,
  updateStepsInformation,
} from "../helpers";

export default {
  name: "OffersReEnrollment",
  components: {
    ConsultValidationRem
  },
  data: () => ({
    offers: [],
    error: "",
    course: null,
  }),
  methods: {
    goTo(route, offer) {
      this.$router.push(route);
      updateStepsInformation({ offer });
    },
  },

  mounted() {
    const { course } = getStepsInformation();
    const loginData = getLoginDataFromStorage();
    this.course = course;
    if (course.DATAMINREM) {
      let formatDate = formatDateToUSA(course.DATAMINREM);

      this.$vs.loading({
        color: "danger",
      });
      new Course()
        .getOffersREM(course.IDHABILITACAOFILIAL, course.RA, formatDate)
        .then(({ data }) => {
          let offer = data;
          updateStepsInformation({ offer });
          this.offers = Array.isArray(data) ? data : [data];
          if (loginData.RA) {
            //quando aluno logado, filtrar somente as ofertas do curso selecionado.
            this.offers = this.offers.filter(function (offer) {
              return offer.IDHABILITACAOFILIAL == course.IDHABILITACAOFILIAL;
            });
          }
          let CODDISC = 0;
          let electives = [{ CODDISC }, { CODDISC }, { CODDISC }];
          updateStepsInformation({ electives });
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    } else {
      this.error =
        "O sistema não conseguiu obter informação de data mínima para rematrícula. Favor contate o suporte. Se você é aluno, faça contato com a secretaria da sua unidade QI.";
    }
  },
};
</script>
